import fetch from '../../auth/FetchInterceptor';
import { API_URL } from '../../configs/AppConfig';

export function requestLogError(data) {
  return fetch.post(`${API_URL}/api/app/uierror`, data);
}
